module.exports = __webpack_public_path__ + "img/history.0e2b5513.png";